import { CORE_PATH } from '@shared/api/paths';

const MAIN_PATH = 'TelegramBot';

export const path = `${CORE_PATH}/${MAIN_PATH}`;
